import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-hamburger', function() {
        $('.b-header').toggleClass('opened');
        $('html').toggleClass('position-fixed');
        $('body').toggleClass('position-fixed');
    });
    $(document).on('click', '.js-hamburger-close', function() {
        $('.b-header').removeClass('opened');
        $('html').removeClass('position-fixed');
        $('body').removeClass('position-fixed');
    });
    $('.b-header__hamburger-inner-list').hide();
    $(document).on('click', '.js-hamburger-item', function(e) {
    	if (!((e.target).closest('.b-header__hamburger-inner-list'))) {
            $('.b-header__hamburger-inner-list').slideUp();
            if ($(this).next('.b-header__hamburger-inner-list').is(":visible")) {
                $(this).parents('.b-header__hamburger-item').removeClass('active');
                $(this).next('.b-header__hamburger-inner-list').slideUp();
            } else {
                $('.b-header__hamburger-item').removeClass('active');
                $(this).parents('.b-header__hamburger-item').addClass('active');
                $(this).next('.b-header__hamburger-inner-list').slideDown();
            }
    	}
    });
});


// WEBPACK FOOTER //
// ./src/js/general/hamburger.js